
		<a
			target="_blank"
			rel="noreferrer"
			[routerLink]="['/api/support/negotiator/gotosupport' + (_value ? '?value=' + _value : '')]"
			[queryParams]="queryParams"
		>
			<ng-content></ng-content>
			<ng-template [ngIf]="title">
				{{ title }}
			</ng-template>
		</a>
	